module.exports = __webpack_public_path__ + "media/images/footer_colorized-ec2a96dc16bdbe7605e8a577c8a377d5.png";